import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=75be7774&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75be7774')) {
      api.createRecord('75be7774', component.options)
    } else {
      api.reload('75be7774', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=75be7774&", function () {
      api.rerender('75be7774', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dbpPba5pKXu4/JS/comp/ImgFallback.vue"
export default component.exports